import * as yup from "yup";

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for name")
    .label("Package Name"),
  company: yup.string().required().label("Company"),
  sampleVariant: yup.string().required().label("Variant"),
  commodity: yup.string().required().label("Commodity"),
  tests: yup.array().min(1).of(yup.string()).required().label("Parameter"),
  // image: yup
  //   .array()
  //   .min(1, "You must upload at least one image")
  //   .max(1, "You can only upload one image")
  //   .optional()
  //   .test("is-image", "All files must be image types", (files) => {
  //     return (
  //       Array.isArray(files) &&
  //       files.length > 0 &&
  //       files.every((file) => file?.originFileObj?.type?.startsWith("image/"))
  //     );
  //   }),
});

export default schema;
